exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vux-x-img, .b-lazy {\n  -webkit-transition: opacity 500ms ease-in-out;\n  transition: opacity 500ms ease-in-out;\n  max-width: 100%;\n}\n.b-lazy {\n  opacity: 0;\n}\n.b-lazy.b-loaded {\n  opacity: 1;\n}\n", ""]);

// exports
